import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.open(`${mainSiteUrl}/search?q=${encodeURIComponent(searchQuery.trim())}`, '_blank', 'noopener');
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20curated%20fashion%20essentials%20scattered%20on%20warm%20terracotta%20textured%20surface%2C%20sunglasses%20jewelry%20and%20fabric%20swatches%2C%20dramatic%20diagonal%20shadows%20from%20window%20blinds%2C%20editorial%20product%20photography%20with%20rich%20contrast%2C%20elegant%20bohemian%20aesthetic%2C%20warm%20earthy%20tones&width=1800&height=1200&seq=hero-bg-v2-superbuy&orientation=landscape"
          alt="Superbuy Spreadsheet fashion shopping resources"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/75 via-background-50/50 to-background-50/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-6 tracking-wide">
          <i className="ri-sparkling-line"></i>
          Updated 2026 · Trusted by 50K+ Shoppers
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-tight mb-6">
          Superbuy Spreadsheet
          <br />
          <span className="text-primary-600">The Smartest Way</span> To Discover
          <br />
          Products & Shop Better
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          Access organized Superbuy Spreadsheet resources with product categories,
          buying guides, comparison tools and expert tips designed for international shoppers.
        </p>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="max-w-xl mx-auto mb-8">
          <div className="relative flex items-center">
            <div className="absolute left-4 text-foreground-400">
              <i className="ri-search-line text-lg"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Superbuy Spreadsheet resources..."
              className="w-full pl-12 pr-28 py-3.5 bg-background-50/90 backdrop-blur-sm border border-background-200 rounded-full text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
            />
            <button
              type="submit"
              className="absolute right-1.5 px-5 py-2 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Search
            </button>
          </div>
        </form>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/what-is-superbuy-spreadsheet"
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all transform hover:scale-[1.02] whitespace-nowrap cursor-pointer"
          >
            Explore Superbuy Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3 bg-background-50/90 backdrop-blur-sm text-foreground-800 text-sm font-semibold rounded-full border border-background-300 hover:border-foreground-300 hover:bg-background-50 transition-all whitespace-nowrap cursor-pointer"
          >
            Visit Our Main Website
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
            Updated Spreadsheet Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
            Organized Product Categories
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
            Beginner Friendly Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
            Safety Focused Shopping Tips
          </span>
        </div>

        {/* Scroll indicator */}
        <div className="mt-16 animate-bounce">
          <i className="ri-arrow-down-s-line text-2xl text-foreground-400"></i>
        </div>
      </div>
    </section>
  );
}